import React from "react";
import {Warning} from "@phosphor-icons/react";

const Unauthorized = () => {
    return (
        <div className='app__unauthorized'>
            <Warning size={100} />
            <h1>Unauthorized</h1>
            <br/>
            <p>You do not have permission to access this page.</p>
        </div>
    );
}

export default Unauthorized;